module.exports = __webpack_public_path__ + "img/pic2.f4f4caa1.png";